import React from 'react';
import { Users, School, Heart, Award, Calendar, Building } from 'lucide-react';

const WelfareSociety = () => {
  return (
    <div className="w-full mx-auto px-4 py-12 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
      {/* Header Section */}
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold text-gray-800 mb-4 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
          Welfare Society
        </h1>
        <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 mx-auto rounded-full"></div>
      </div>

      {/* Society Section */}
      <div className="bg-white rounded-2xl shadow-xl p-8 mb-12 border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
        <div className="flex items-center mb-6">
          <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-3 rounded-full mr-4">
            <Users className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800">Our Society</h2>
        </div>
        
        <div className="prose prose-lg text-gray-700 leading-relaxed space-y-4">
          <p>
            Education Welfare Society was formed by our visionary Chairman who was nominated as Secretary 
            in the society under the guidance of <span className="font-semibold text-blue-700">Mr. Suresh Chandra Joshi</span>, 
            a businessman by profession who was appointed as the president of the society in 1993.
          </p>
          
          <p>
            The society was formed with a vision to explore education in the area of Tularampur, and started 
            our first school namely <span className="font-semibold text-green-700">Ever Green Public School</span> with 
            minimum funds and infrastructure but the vision was to give the best to the students and society 
            - which remains our mission today.
          </p>
        </div>
      </div>

      {/* Community Programs */}
      <div className="bg-white rounded-2xl shadow-xl p-8 mb-12 border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
        <div className="flex items-center mb-6">
          <div className="bg-gradient-to-r from-green-500 to-emerald-500 p-3 rounded-full mr-4">
            <Heart className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800">Community Programs</h2>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6 mb-6">
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200">
            <h3 className="text-xl font-semibold text-green-800 mb-3">Regular Programs</h3>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-center"><Calendar className="w-4 h-4 mr-2 text-green-600" />Health camps</li>
              <li className="flex items-center"><Award className="w-4 h-4 mr-2 text-green-600" />Marathon on Kargil Vijay Diwas</li>
              <li className="flex items-center"><Users className="w-4 h-4 mr-2 text-green-600" />Co-curricular competitions</li>
              <li className="flex items-center"><Heart className="w-4 h-4 mr-2 text-green-600" />Women awareness programs</li>
              <li className="flex items-center"><School className="w-4 h-4 mr-2 text-green-600" />Child safety programs</li>
            </ul>
          </div>
          
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200">
            <h3 className="text-xl font-semibold text-blue-800 mb-3">Donation Initiatives</h3>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-center"><Heart className="w-4 h-4 mr-2 text-blue-600" />COVID-19 meal donation programs</li>
              <li className="flex items-center"><School className="w-4 h-4 mr-2 text-blue-600" />Dress to needy primary students</li>
              <li className="flex items-center"><Building className="w-4 h-4 mr-2 text-blue-600" />Furniture for primary schools</li>
              <li className="flex items-center"><Users className="w-4 h-4 mr-2 text-blue-600" />Community festival support</li>
            </ul>
          </div>
        </div>
        
        <p className="text-gray-600 italic bg-gray-50 p-4 rounded-lg border-l-4 border-green-500">
          Supporting community programs like Ramleela, Krishna Leela, Ganesh Mahotsav and more
        </p>
      </div>

      {/* Our Schools */}
      <div className="bg-white rounded-2xl shadow-xl p-8 mb-12 border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
        <div className="flex items-center mb-6">
          <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-3 rounded-full mr-4">
            <School className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800">Our Educational Institutions</h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-green-100 to-emerald-100 p-6 rounded-xl border-2 border-green-200 hover:border-green-300 transition-colors">
            <div className="text-center">
              <div className="bg-green-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <School className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-green-800 mb-2">Ever Green Public School</h3>
              <p className="text-green-700">Our founding institution in Tularampur</p>
              <span className="inline-block bg-green-200 text-green-800 px-3 py-1 rounded-full text-sm mt-2">Est. 1993</span>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-100 to-indigo-100 p-6 rounded-xl border-2 border-blue-200 hover:border-blue-300 transition-colors">
            <div className="text-center">
              <div className="bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Building className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-blue-800 mb-2">Immortal International School</h3>
              <p className="text-blue-700">Located in Haripur Bacchi, Halduchaur</p>
              <span className="inline-block bg-blue-200 text-blue-800 px-3 py-1 rounded-full text-sm mt-2">Est. 2019</span>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-pink-100 to-rose-100 p-6 rounded-xl border-2 border-pink-200 hover:border-pink-300 transition-colors">
            <div className="text-center">
              <div className="bg-pink-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-pink-800 mb-2">Berrybees Pre School</h3>
              <p className="text-pink-700">Pre-Primary section expansion</p>
              <span className="inline-block bg-pink-200 text-pink-800 px-3 py-1 rounded-full text-sm mt-2">Est. 2022</span>
            </div>
          </div>
        </div>
      </div>

      {/* Leadership */}
      <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
        <div className="flex items-center mb-6">
          <div className="bg-gradient-to-r from-indigo-500 to-purple-500 p-3 rounded-full mr-4">
            <Award className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800">Our Leadership</h2>
        </div>
        
        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-6 rounded-xl border border-indigo-200">
          <p className="text-gray-700 text-lg leading-relaxed">
            At present, the society comprises <span className="font-bold text-indigo-700">7 intellectual members</span> with 
            a shared vision of growth and success. Our dedicated members are supporting all branches positively 
            to achieve greater heights in education and community service.
          </p>
        </div>
      </div>

      {/* Vision Statement */}
      <div className="text-center mt-12 bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-8 rounded-2xl shadow-xl">
        <h3 className="text-2xl font-bold mb-4">Our Vision</h3>
        <p className="text-xl italic">
          "Exploring education and nurturing communities for a brighter tomorrow"
        </p>
      </div>
    </div>
  );
};

export default WelfareSociety;